import { FoodCollectionList } from "@corpuscomplete/core-ui/nutrition/food-collection/list";
import { CollectionsPage } from "@corpuscomplete/web/modules/common/collections/pages/collections";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/spaces/$spaceId/collections/")({
  component: () => {
    const { spaceId } = Route.useParams();
    return <CollectionsPage scope={{ kind: "space", spaceId }} />;
  },
  loader: async ({ context: { zero } }) => {
    if (zero) {
      FoodCollectionList.preload(zero);
    }
  },
});
